import { VindrTableProps } from '@vindr/ui';
import { WritableDraft } from 'immer/dist/internal';

export default function onPaginationChange(
  draft: WritableDraft<VindrTableProps['pagination']>,
  pagination: VindrTableProps['pagination']
) {
  draft.page = pagination.page;
  draft.size = pagination.size;
}
